module.exports = __webpack_public_path__ + "img/sample-room-1.97a866ed.png";